// Names and help text admins see. The backend's codes stay internal.

export const TABS = [
  { gender: "Female", label: "Salon" },
  { gender: "Male", label: "Bridal" },
];

export const SECTION_TYPES = {
  LIVE_BOOKING: { label: "Live booking strip", help: "Shows the customer's booking in progress with the beautician's name. Only for logged-in customers with an active booking.", personal: true },
  HERO_CAROUSEL: { label: "Offer carousel", help: "The tab's active banners. Manage the images under Banners." },
  CATEGORY_GRID: { label: "Category grid", help: "Category tiles for this tab. Price buckets (Under ₹800…) are left out; use collections for those." },
  COUPONS: { label: "Coupons", help: "Visible coupon codes. New-customer codes are shown only to customers without a completed booking." },
  RATING_PROMPT: { label: "Rate your last service", help: "Asks about the latest completed booking without a rating. Replaces the blocking feedback sheet.", personal: true },
  BOOK_AGAIN: { label: "Book again", help: "Services from the customer's past completed bookings.", personal: true },
  SERVICE_RAIL: { label: "Service rail (collection)", help: "A row of service cards from a collection, with See all. Use it for Packages under ₹800, Glow with our facials, and so on." },
  DEAL: { label: "Deal of the day", help: "A service with a live campaign price, with a countdown to the campaign end. Set the campaign price and dates on the service." },
  MOST_BOOKED: { label: "Most booked", help: "Automatic: services booked most in the last 7 or 30 days, with category chips." },
  TRUST: { label: "Why Barbera (trust)", help: "Real totals from completed bookings, plus your promises and brands." },
  REFER: { label: "Refer & earn", help: "Reads the active referral reward." },
  CONSULT: { label: "Consultation card", help: "A call-to-action card, for example the bridal free consultation." },
  PACKAGE_BUILDER: { label: "Build your package", help: "Entry card for the package builder. Hidden until a builder is published for this tab under Package Builder." },
  OCCASIONS: { label: "Shop by occasion", help: "Large photo tiles per category with its lowest price (\"from ₹2,999\"). Categories without active services are left out. To choose and order them, put {\"categoryIds\": [\"…\"]} in Advanced." },
  JOURNEY: { label: "How it works (steps)", help: "Numbered steps, for example consultation → booking → the big day." },
  FAQ: { label: "Questions & answers", help: "Tap-to-open questions. Only answers the service actually keeps." },
};

export const CARD_STYLES = {
  COMPACT: "Compact (128 px, square photo)",
  LARGE: "Large (200 px, 4:3 photo)",
  PACKAGE: "Package (248 px, contents listed)",
};

export const AUDIENCES = {
  ALL: "Everyone",
  NEW: "New customers (no completed booking)",
  REPEAT: "Repeat customers",
};

export const SORTS = {
  MOST_BOOKED: "Most booked first",
  RATING: "Best rated first",
  PRICE_ASC: "Price: low to high",
  PRICE_DESC: "Price: high to low",
  NEWEST: "Newest first",
  MANUAL: "In the order I pick",
};

export const STATUS_STYLES = {
  LIVE: "bg-green-100 text-green-800",
  DRAFT: "bg-amber-100 text-amber-800",
  ARCHIVED: "bg-gray-200 text-gray-700",
};

export const inr = (n) => (n == null ? "" : `₹${Number(n).toLocaleString("en-IN")}`);

export const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" })
    : "";

// Value for <input type="datetime-local"> from an ISO string, and back.
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : null);

export const parseJson = (text, fallback = {}) => {
  try {
    const v = JSON.parse(text || "{}");
    return v && typeof v === "object" ? v : fallback;
  } catch (e) {
    return fallback;
  }
};

export const ruleSummary = (rule, categoryNames = {}) => {
  const r = parseJson(rule);
  const parts = [];
  if (r.gender) parts.push(r.gender === "Female" ? "Salon" : "Bridal");
  if (r.isPackage === true) parts.push("packages");
  if (r.isPackage === false) parts.push("single services");
  if (r.categoryIds?.length) parts.push(r.categoryIds.map((id) => categoryNames[id] || "category").join(", "));
  if (r.minPrice != null && r.maxPrice != null) parts.push(`${inr(r.minPrice)}–${inr(r.maxPrice)}`);
  else if (r.maxPrice != null) parts.push(`up to ${inr(r.maxPrice)}`);
  else if (r.minPrice != null) parts.push(`from ${inr(r.minPrice)}`);
  if (r.maxDuration != null) parts.push(`≤ ${r.maxDuration} min`);
  if (r.hasCampaign) parts.push("on campaign");
  if (r.createdWithinDays) parts.push(`added in last ${r.createdWithinDays} days`);
  return parts.join(" · ") || "All active services";
};
